import { graphql, HeadProps } from 'gatsby';
import React, { ReactElement } from 'react';
import AbTestingService from 'atoms/AbTesting/AbTestingService';
import { HeadComponent } from 'atoms/Head/head';
import HomepageView from 'src/app/views/homepage';
import HomepageExperimentView from 'src/app/views/experiments/homepage_hero_headline_change/homepage';
import { DefaultStaticSEOPageProps } from 'src/types/pages';
import { usePageMetadata } from 'src/hooks/usePageMetadata';
import { Language } from 'src/utils/i18n-config';

const IndexPage = (props: DefaultStaticSEOPageProps): ReactElement => {
  return AbTestingService<DefaultStaticSEOPageProps['data'], unknown>({
    props,
    experimentName: 'homepage_hero_headline_change',
    getterLabel: 'new_version',
    control: {
      data: props.data,
      template: HomepageView,
    },
    variant: {
      data: props.data,
      template: HomepageExperimentView,
    },
  });
};

export default IndexPage;

export const Head = (props: HeadProps<DefaultStaticSEOPageProps['data'], { language: Language }>): JSX.Element => {
  const { title, description } = usePageMetadata(props.pageContext.language, props.location.pathname);

  const helmet = {
    title,
    description,
    previewImageURL: props.data.seoImage.file.url,
  };

  return (
    <HeadComponent
      helmet={helmet}
      location={props.location}
    />
  );
};

export const pageQuery = graphql`
  query LandingPageQuery {
    articles: allContentfulCaseStudy2025(sort: { createdAt: DESC }) {
      edges {
        node {
          ...CaseStudy2025Content
        }
      }
    }
    seoImage: contentfulAsset(contentful_id: { eq: "3Oe871ww60CDt3yYp4ULpd" }) {
      file {
        url
      }
    }
  }
`;
